import { EnumMyCourseMenu, EnumMyStudyMenu, EnumMyAccountMenu } from '@xt/client/enums/my-v2'

export const myCourseMenu = [
  { label: '全部课程', value: '', component: 'AllCourse' },
  {
    label: '林曦老师亲授',
    value: EnumMyCourseMenu.Teach,
    component: 'TeachCourse'
  },
  {
    label: '林曦老师监制',
    value: EnumMyCourseMenu.Product,
    component: 'ProductCourse'
  },
  {
    label: '线下课',
    value: EnumMyCourseMenu.Offline,
    component: 'OfflineCourse'
  }
]

export const myStudyMenu = [
  { label: '作业', value: EnumMyStudyMenu.Homework, component: 'HomeworkStudy' },
  {
    label: '作品',
    value: EnumMyStudyMenu.Reward,
    component: 'RewardStudy'
  },
  {
    label: '日常',
    value: EnumMyStudyMenu.Daily,
    component: 'DailyStudy'
  },
  {
    label: '收藏',
    value: EnumMyStudyMenu.Collect,
    component: 'CollectStudy'
  }
]

export const myAccountMenu = [
  { label: '订单', value: EnumMyAccountMenu.Order, component: 'OrderAccount' },
  {
    label: '笔山',
    value: EnumMyAccountMenu.Bishan,
    component: 'BishanAccount'
  },
  {
    label: '桐板儿',
    value: EnumMyAccountMenu.Coin,
    component: 'CoinAccount'
  },
  {
    label: '卡劵',
    value: EnumMyAccountMenu.Packs,
    component: 'PacksAccount'
  },
  {
    label: '积分兑换',
    value: EnumMyAccountMenu.Exchange,
    component: 'ExchangeAccount'
  }
]
